<script>
	import galleryCarousel from './gallery-carousel.vue';
	import axios from 'axios';

  export default {
    template: '<a href="#" v-on:click="openCarousel($event)" class="c-gallery-block__btn c-btn c-btn--large c-btn--brand"><span class="c-btn__loading" v-bind:class="{isLoading: this.loading}"><slot>Gallery</slot></span></a>',
		name: 'v-gallery-block',
		data: function () {
			return {
				loading: false,
				carouselData : {
					component: galleryCarousel,
					props    : {
						items : [],
						index  : 0
					}
				}
			}
		},
		props : {
			galleryId : {
				type : Number
			}
		},
		methods : {
			openCarousel(e) {
				e.preventDefault()
				this.loading = true;
				axios.get('/api/gallery-block/'+ this.galleryId +'.json', { crossdomain: true })
				.then((response) => {
						this.loading = false;
						this.carouselData.props.items = response.data.data;
						this.$store.dispatch('changeModalContent', this.carouselData);
						this.$store.dispatch('openModal');
				});
			}
		}
  }
</script>



// WEBPACK FOOTER //
// gallery-block.vue?14ecd30e